import React from 'react';
import Icons from 'components/icons';
import styles from './textarea.module.scss';

const Textarea = ({
  label,
  error,
  onReset,
  ...rest
}) => (
  <div className={styles.input}>
    {label ? (
      <div className={styles.label}>
        <label>{label}</label>
      </div>
    ) : null}
    <div className={`${styles.target} ${error ? styles.targetError : ''}`}>
      {error ? (
        <a className={styles.errorIcon} onClick={onReset} onKeyDown={() => {}} title="Сбросить значение">
          <Icons name="cancel" />
        </a>
      ) : null}
      <textarea {...rest} />
    </div>
    {error ? (
      <div className={styles.error}>{error}</div>
    ) : null}
  </div>
);

export default Textarea;
